module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAAXNSR0IArs4c6QAAAFRQTFRFAAAAIGDvKmrvLGjrKmfsKWnsLGjtLGjrLGnsK2jsK2jsK2nsK2jrK2nrK2nsLGjrLGjsLGnrLGnsLGntYI7wYY7xsMf4vND5vdD5ytn6y9r7////AvNwjQAAAAx0Uk5TABAwQE9Qf4CvsN/gCQCnyQAAAJlJREFUOMutk9sSgjAMRFMucodSLdT6//+pLTP6lCWtnOczm0wyS6R6A+kVEZXmhPKQ5oVl/kqipB/2GbFQ8q+Iw0nOf3A4Cew0aZYpIUl12OnCxWVUN0gVnOJspyLrLTLJPgJY2o7fbf9LxkauWJyRRMekuoHU4v+qFk9rU8o5rixjdjn30M39inL6SHY59Z1Fp5RzwM6g6A2q5UtEIO/tcQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/saveNotarHover.png
// module id = mHsA
// module chunks = 1